import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const STATUS = {
  nuevo: { label: "Nuevo", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  contactado: { label: "Contactado", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  cerrado: { label: "Cerrado", cls: "bg-gray-100 text-gray-700 border-gray-200" },
};

const fmt = (v) => {
  if (!v) return "-";
  try {
    return new Date(v).toLocaleString("es-AR", { timeZone: "America/Argentina/Buenos_Aires" });
  } catch {
    return String(v);
  }
};

// ===== Boton + modal para el cliente (aviso de trial) =====
export const QuoteRequestButton = ({ className = "" }) => {
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ message: "", phone: "", contact_email: "" });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError("");
    try {
      const token = localStorage.getItem("token");
      await axios.post(`${API}/quote-requests`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`ml-auto bg-orange-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-orange-700 transition-colors whitespace-nowrap ${className}`}
        data-testid="quote-request-open-btn"
      >
        Quiero mi presupuesto
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div
            className="bg-white rounded-lg shadow-xl w-full max-w-lg p-6"
            data-testid="quote-request-modal"
          >
            {sent ? (
              <div className="text-center py-4" data-testid="quote-request-success">
                <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-green-100 text-green-700 flex items-center justify-center text-2xl font-bold">
                  ✓
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Consulta enviada</h3>
                <p className="text-sm text-gray-600 mb-6">
                  Recibimos tu pedido de presupuesto. Nos vamos a poner en contacto a la brevedad
                  para armar un plan a la medida de tu empresa.
                </p>
                <button
                  onClick={() => {
                    setOpen(false);
                    setSent(false);
                    setForm({ message: "", phone: "", contact_email: "" });
                  }}
                  className="px-5 py-2 rounded-lg bg-gray-900 text-white text-sm font-medium hover:bg-gray-800"
                  data-testid="quote-request-close-btn"
                >
                  Cerrar
                </button>
              </div>
            ) : (
              <form onSubmit={submit}>
                <h3 className="text-lg font-bold text-gray-900">Pedir presupuesto</h3>
                <p className="text-sm text-gray-600 mt-1 mb-5">
                  Armamos el plan según el tamaño y las necesidades de tu empresa. Contanos qué
                  necesitás y te respondemos con una propuesta.
                </p>

                <label className="block text-sm font-medium text-gray-700 mb-1">
                  ¿Qué necesitás?
                </label>
                <textarea
                  rows={4}
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="Cantidad de objetivos a monitorear, módulos que te interesan, plazos..."
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  data-testid="quote-request-message-input"
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Teléfono <span className="text-gray-400 font-normal">(opcional)</span>
                    </label>
                    <input
                      type="text"
                      value={form.phone}
                      onChange={(e) => setForm({ ...form, phone: e.target.value })}
                      placeholder="+54 9 11 ..."
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      data-testid="quote-request-phone-input"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email de contacto <span className="text-gray-400 font-normal">(opcional)</span>
                    </label>
                    <input
                      type="email"
                      value={form.contact_email}
                      onChange={(e) => setForm({ ...form, contact_email: e.target.value })}
                      placeholder="Usamos el de tu cuenta si lo dejás vacío"
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      data-testid="quote-request-email-input"
                    />
                  </div>
                </div>

                {error && (
                  <p className="mt-3 text-sm text-red-600" data-testid="quote-request-error">
                    {error}
                  </p>
                )}

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    type="button"
                    onClick={() => setOpen(false)}
                    className="px-4 py-2 rounded-lg border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
                    data-testid="quote-request-cancel-btn"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    disabled={sending}
                    className="px-5 py-2 rounded-lg bg-orange-600 text-white text-sm font-semibold hover:bg-orange-700 disabled:opacity-60"
                    data-testid="quote-request-submit-btn"
                  >
                    {sending ? "Enviando..." : "Enviar consulta"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
};

// ===== Listado para el panel de administracion =====
export const QuoteRequestsAdmin = () => {
  const [items, setItems] = useState([]);
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API}/admin/quote-requests`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setItems(res.data.items || []);
      setCounts(res.data.counts || {});
    } catch (err) {
      console.error("quote requests:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const setStatus = async (id, status) => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `${API}/admin/quote-requests/${id}`,
        { status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setItems((prev) => prev.map((i) => (i.id === id ? { ...i, status } : i)));
      setCounts((prev) => ({ ...prev, _dirty: true }));
    } catch (err) {
      alert("Error: " + (err.response?.data?.detail || err.message));
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6" data-testid="quote-requests-admin">
      <h2 className="text-xl font-bold text-gray-800 flex items-center">
        <span className="mr-3">📨</span>
        Consultas de Presupuesto
      </h2>
      <p className="text-sm text-gray-600 mt-1 mb-5">
        Pedidos enviados por los clientes desde el aviso de prueba gratuita, cuando el panel de
        precios está oculto.
      </p>

      <div className="flex gap-2 mb-5 flex-wrap">
        {Object.keys(STATUS).map((k) => (
          <span
            key={k}
            className={`text-xs font-semibold px-3 py-1 rounded-full border ${STATUS[k].cls}`}
            data-testid={`quote-count-${k}`}
          >
            {STATUS[k].label}: {counts[k] || 0}
          </span>
        ))}
      </div>

      {loading && <p className="text-sm text-gray-500 py-6 text-center">Cargando consultas...</p>}

      {!loading && items.length === 0 && (
        <p className="text-sm text-gray-500 py-10 text-center" data-testid="quote-requests-empty">
          Todavía no hay consultas de presupuesto.
        </p>
      )}

      <div className="space-y-3">
        {items.map((q) => (
          <div
            key={q.id}
            className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors"
            data-testid={`quote-request-item-${q.id}`}
          >
            <div className="flex items-start justify-between flex-wrap gap-2">
              <div>
                <p className="font-semibold text-gray-900">{q.company_name || "(sin empresa)"}</p>
                <p className="text-xs text-gray-500">
                  {q.contact_name} · {q.contact_email}
                  {q.phone ? ` · ${q.phone}` : ""}
                  {q.subscription_plan ? ` · plan ${q.subscription_plan}` : ""}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <span
                  className={`text-xs font-semibold px-2 py-1 rounded-full border ${
                    (STATUS[q.status] || STATUS.nuevo).cls
                  }`}
                  data-testid={`quote-status-${q.id}`}
                >
                  {(STATUS[q.status] || STATUS.nuevo).label}
                </span>
                <span className="text-xs text-gray-400">{fmt(q.created_at)}</span>
              </div>
            </div>

            {q.message && (
              <p className="text-sm text-gray-700 mt-3 whitespace-pre-wrap">{q.message}</p>
            )}

            <div className="flex gap-2 mt-3">
              {Object.keys(STATUS)
                .filter((k) => k !== q.status)
                .map((k) => (
                  <button
                    key={k}
                    onClick={() => setStatus(q.id, k)}
                    className="text-xs px-3 py-1 rounded-md border border-gray-300 text-gray-700 hover:bg-white"
                    data-testid={`quote-set-${k}-${q.id}`}
                  >
                    Marcar {STATUS[k].label.toLowerCase()}
                  </button>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
